
import { useStore } from 'vuex'
import { computed } from 'vue'

export default {
    name: "DeleteFrivilligjobOverlay",
    setup(){
        const store = useStore()
        const isSubmitting = computed(()=> store.state.frivilligprofil.is_submitting)
        const frivilligjobId = computed(() => store.state.main.page_overlay_content_data.frivilligjobId)
        const redirectUrl = computed(() => store.state.main.page_overlay_content_data.redirectAfterDeleteUrl)

        const submitConfirmDelete = () => {
            store.dispatch("frivilligjob/deleteFrivilligjob", frivilligjobId.value)
                .then((_) => {
                    window.location.href = redirectUrl.value
                });
        };

        const closeOverlay = function() {
            store.dispatch('main/closePageOverlay')
        }

        const handleRegret = () => {
            closeOverlay()   
        };

        const getLabel = (labelKey, replacements) => {
            let label = store.getters['labels/getLabel']({ labelCollection: 'DeleteFrivilligjobOverlay', labelKey: labelKey })
            if (replacements) {
                replacements.forEach((replacement, index) => {
                    label = label.replace(`{${index}}`, replacement)
                })
            }
            return label
        }

        return {
            isSubmitting,
            getLabel,
            handleRegret,
            submitConfirmDelete
        }
        
    }
}